import type { FaireProductEntity } from "../../entity_types/product";

export const p_9pm84vbjg7: FaireProductEntity = {
  token: "p_9pm84vbjg7",
  type: "product",
  name: "Boris 18K Gold Non-Tarnish CZ Square Thin Ring",
  brandToken: "b_3tzh9mjdm6",
  brandName: "Flânerie by MAIQ",
  imageUrl:
    "https://cdn.faire.com/fastly/175a674769a345baa148f1e107d5d3dcc711ee465a49c707ebe55613d2dc5616.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/750d4627923f92d75282e9abc496e77b21c0aabe18fe38e540da916f33c7b159.jpeg",
    "https://cdn.faire.com/fastly/03f7b63de1f2ce0a667c4ffda3660ba4a4be0441321ca19834372b4a884abb42.jpeg",
    "https://cdn.faire.com/fastly/cd1fa2b4f88f5f051bbb62103a978aa73d4a31de9e1a93985e45b50a78e00dcd.jpeg",
  ],
  priceDollars: 5.85,
  description:
    "18K Gold Non-Tarnish CZ Square Thin Ring\n18K Gold Plating\nStainless Steel\nCubic Zirconia\nSize 7 Measurement: 0.682 Diameter/2.14 Circumference\nSize 8 Measurement: 0.714 Diameter/2.24 Circumference\n \n- Lead-free, Nickel-safe\n- Hypoallergenic\n- Water Resistant",
  tags: [],
  msrpDollars: 19.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:20.811Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
